export enum FeatureEnum {
  positionSignature = 1,
  positionRubric = 2,
  dashboardSignFree = 3,
  firstEnvelope = 4,
  newWorking = 5,
  signaturePackageIsLow = 6,
  signaturePackageIsOut = 7,
  rejectedSignature = 8,
  systemWhatsAppNumberChange = 9,
  positionForm = 10,
  inboxSortOrder = 11,
  sentSortOrder = 12
}
